import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/shipment/stocks1c'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class Stocks1cApi {

    static async getStocks({ data = { ipid: undefined, search: undefined, tab: undefined, providerId: undefined, page: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getstocks', method: 'POST', data, notify: { success: false }, ...params })
    }

    // static async uploadExcelStocks({ data = { ipid: undefined, file: undefined, date: undefined }, ...params }) {
    //     return await fetchService({ url: '/savestocks', method: 'POST', data, ...params })
    // }

    static async uploadExcelStocksPeriod({ data = { ipid: undefined, file: undefined, date: undefined, byPeriod: undefined }, ...params }) {
        return await fetchService({ url: '/savestocksperiod', method: 'POST', data, ...params })
    }

    // static async uploadExcelStocks45({ data = { ipid: undefined, file: undefined, date: undefined }, ...params }) {
    //     return await fetchService({ url: '/savestocks45', method: 'POST', data, ...params })
    // }

    static async updloadGTD({ data = { ipid: undefined, file: undefined, date: undefined, byPeriod: undefined }, ...params }) {
        return await fetchService({ url: '/savegtd', method: 'POST', data, ...params })
    }

    static async saveNds({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/savends', method: 'POST', data, ...params })
    }

    static async dereserve({ data = undefined, ...params }) {
        return await fetchService({ url: '/dereserve', method: 'POST', data, ...params })
    }

    static async clear({ data = { ipid: undefined }, ...params }) {
        return await fetchService({ url: '/clear', method: 'POST', data, ...params })
    }



    static async dereserveByPostingProduct({ data = { postingNumber: undefined, productId: undefined }, ...params }) {
        return await fetchService({ url: '/dereservebypostingproduct', method: 'POST', data, ...params })
    }




    // static async getStocksByPostings({ data = { ip: undefined, search: undefined, providerId: undefined, page: undefined, limit: undefined }, ...params }) {
    //     return await fetchService({ url: '/getstocksbypostings', method: 'POST', data, ...params })
    // }

    // static async updateStocksByPostings({ data = undefined, ...params }) {
    //     return await fetchService({ url: '/updatestocksbypostings', method: 'POST', data, ...params })
    // }

    static async excelStocks({ data = { type: undefined, ipid: undefined, search: undefined, tab: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelstocks', method: 'POST', data, options: { download: true }, ...params })
    }


    static async xmlUPD({ data = { inputRows: undefined }, ...params }) {
        return await fetchService({ url: '/xmlupd', method: 'POST', data, options: { download: true }, ...params })
    }


}